module.exports = __webpack_public_path__ + "img/frame.35942dd0.png";